module.exports = __webpack_public_path__ + "static/media/icon-doc-time.012ab338.svg";